
import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
                <i className="ri-bank-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-gray-900">LoanGuide Pro</span>
            </Link>
            <Link to="/" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-lg text-gray-600 mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Acceptance of Terms</h2>
              <p className="text-gray-700 mb-4">
                By accessing and using LoanGuide Pro, you accept and agree to be bound by the terms 
                and provision of this agreement.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Service Description</h2>
              <p className="text-gray-700 mb-4">
                LoanGuide Pro provides access to mortgage guidelines and related information for 
                mortgage professionals. Our service includes:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Searchable database of mortgage guidelines</li>
                <li>Regular updates from major agencies</li>
                <li>Professional tools and resources</li>
                <li>Customer support and assistance</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Subscription and Payment</h2>
              <p className="text-gray-700 mb-4">
                Our service operates on a subscription basis with the following terms:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>14-day free trial for new users</li>
                <li>Monthly or annual subscription options</li>
                <li>Automatic renewal unless cancelled</li>
                <li>Secure payment processing through Stripe</li>
                <li>Refunds available within 30 days of purchase</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">User Responsibilities</h2>
              <p className="text-gray-700 mb-4">
                As a user of our service, you agree to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Provide accurate account information</li>
                <li>Maintain the security of your account</li>
                <li>Use the service for professional purposes only</li>
                <li>Not share account credentials</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Intellectual Property</h2>
              <p className="text-gray-700 mb-4">
                All content, features, and functionality of LoanGuide Pro are owned by us and are 
                protected by copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">
                LoanGuide Pro provides information for reference purposes. We are not responsible for:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Decisions made based on our information</li>
                <li>Accuracy of third-party guidelines</li>
                <li>Service interruptions or technical issues</li>
                <li>Financial losses or business impacts</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Termination</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to terminate or suspend your account at any time for violation 
                of these terms or for any other reason at our sole discretion.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Information</h2>
              <p className="text-gray-700">
                For questions about these Terms of Service, please contact us:
              </p>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                <p className="text-gray-700">
                  <strong>Email:</strong> legal@loanguide.pro<br />
                  <strong>Address:</strong> 123 Business Ave, Suite 100, City, State 12345
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
